// Backend error codes
export const ERROR_CODE_PDF_NO_FORM_FIELDS = 5094;
export const ERROR_CODE_PDF_CORRUPTED_FORM_FIELDS = 50941;
